/* tslint:disable */
/* eslint-disable */
/**
 * Hey Pharamcist API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/**
 * 
 * @export
 * @interface Address
 */
export interface Address {
  _id?: string;
    /**
     * 
     * @type {Date}
     * @memberof Address
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof Address
     */
    updatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    user: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    store: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    phone: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    street1: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    street2: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    street3: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    streetNo: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    state: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    zip: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    country: string;
    /**
     * 
     * @type {boolean}
     * @memberof Address
     */
    isDefault: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Address
     */
    isResidential: boolean;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    addressType: AddressAddressTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum AddressAddressTypeEnum {
    Billing = 'Billing',
    Shipping = 'Shipping',
    Both = 'Both'
}

